module.exports = __webpack_public_path__ + "img/img04.a58a14df.png";